const getters = {
  user: state => state.user.data,
  authenticated: state => !!state.user.data,
  page: state => state.page,
};

export default getters;
